import React, { Fragment } from 'react';

import { Card, CardContent, CardHeader, Feed, FeedEvent, FeedLabel, FeedContent, FeedSummary, FeedDate, FeedExtra } from 'semantic-ui-react'

export function PlaylistCard(props) {
  let formatted_date = new Date(props.date).toLocaleDateString("en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric"})
  let color = 'orange';
  if(props.i % 7 === 1) { color = 'teal'; }
  if(props.i % 7 === 2) { color = 'purple'; }
  if(props.i % 7 === 3) { color = 'green'; }
  if(props.i % 7 === 4) { color = 'yellow'; }
  if(props.i % 7 === 5) { color = 'red'; }
  if(props.i % 7 === 6) { color = 'pink'; }

  let width = 290;
  return (
    <Card key={props.date}
      color={color}
      style={{width: width + 'px'}}
    >
      <CardContent>
        <CardHeader>{formatted_date}</CardHeader>
        <div className="card_feeds">
          <Feed key={formatted_date}>
            {props.playlist.map(function(entry, j) {
              return <FeedEvent key={entry.playlist_id}>
                <FeedLabel>{j+1}</FeedLabel>
                <FeedContent>
                  <FeedSummary>
                    {entry.act && 
                      <><a href={'/act/' + entry.act.act_id} key={entry.act.act_id}>{entry.act.name}</a>: </>
                    }
                    {entry.artists && entry.artists.map(function(artist, i) {
                      return <Fragment key={artist.artist_id}>{i > 0 && <>, </>}<a href={'/artist/' + artist.artist_id} key={artist.artist_id}>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</a></Fragment>
                    })}
                  </FeedSummary>
                  {entry['accompaniments'] && 
                    <FeedDate>
                      with {entry['accompaniments'].map(function(accompaniment, i) {
                        return <Fragment key={accompaniment.accompaniment_id}>{i > 0 && <>, </>}{accompaniment.name} ({accompaniment.role})</Fragment>
                      })}
                    </FeedDate>
                  }
                  <FeedExtra>
                    <span>{entry.track}</span>
                    {entry.type !== 'single' && 
                      <FeedDate>from the {entry.type} "{entry.album}"</FeedDate>
                    }
                  </FeedExtra>
                </FeedContent>
              </FeedEvent>
            })}
          </Feed>
          {props.playlist.length === 0 &&
            <div style={{ textAlign: 'center', marginTop: '10px' }}>
              <p>No tracks found</p>
            </div>
          }
        </div>
      </CardContent>
    </Card>
  );
}